/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Costs_SaveInputs */

const id_tld_pricing_costs_save = /** @type {(inputs: Tld_Pricing_Costs_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simpan perubahan`)
};

const en_tld_pricing_costs_save = /** @type {(inputs: Tld_Pricing_Costs_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save changes`)
};

/**
* | output |
* | --- |
* | "Save changes" |
*
* @param {Tld_Pricing_Costs_SaveInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_costs_save = /** @type {((inputs?: Tld_Pricing_Costs_SaveInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Costs_SaveInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_costs_save(inputs)
	return id_tld_pricing_costs_save(inputs)
});